// Internal imports
import { cn } from "@/lib/utils";
import MarketingBlurb from "../components/blurb";
import { Comparison } from "../components/comparison";
import CTA from "../components/cta";
import CsvDownloadSection from "../components/csv-download";
import CustomGradingSection from "../components/custom-grading";
import Faq from "../components/faq";
import Flow from "../components/flow";
import GridPattern from "../components/grid-pattern";
import Hero from "../components/hero";
import Introduction from "../components/introduction";

const LandingPage = () => {
  return (
    <>
      <GridPattern
        width={40}
        height={40}
        x={0}
        y={0}
        strokeDasharray={5}
        className={cn(
          "[mask-image:linear-gradient(to_bottom,white,white,white,transparent)] "
        )}
      />
      <Hero />
      <MarketingBlurb />
      <Comparison />
      <Introduction />
      <CustomGradingSection />
      <CsvDownloadSection />
      <Flow />
      <Faq />
      <CTA />
    </>
  );
};

export default LandingPage;
